var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      directives: [
        {
          name: "b-tooltip",
          rawName: "v-b-tooltip.right",
          value: {
            title: _vm.$t("boards.messages.onlyThisPersonCanToggleStatus"),
            disabled: _vm.canChange,
          },
          expression:
            "{\n    title: $t('boards.messages.onlyThisPersonCanToggleStatus'),\n    disabled: canChange\n  }",
          modifiers: { right: true },
        },
      ],
      ref: "form",
      attrs: { autocomplete: "off" },
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.handleChange(_vm.user.username)
        },
        submit: function ($event) {
          $event.preventDefault()
          $event.stopPropagation()
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "collaborators-dropdown cp-collaborators dropdown-item d-flex flex-row align-items-center",
          class: { clickable: _vm.canChange, disabled: !_vm.canChange },
        },
        [
          _c(
            "profile-avatar",
            _vm._b(
              {
                staticClass: "client-profile-owner-avatar mr-2",
                attrs: { "avatar-options": { inline: false } },
              },
              "profile-avatar",
              Object.assign({}, _vm.user),
              false
            )
          ),
          _vm._v(" "),
          _c("p", { staticClass: "ml-2 mb-0" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm._f("nameFormat")(_vm.user.givenName, _vm.user.familyName)
                ) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ml-auto d-flex flex-row" },
            [
              _c("div", { staticClass: "pretty pb-1 p-switch p-fill" }, [
                _c("input", {
                  attrs: {
                    id: _vm.labelValue,
                    type: "checkbox",
                    disabled: !_vm.canChange,
                  },
                  domProps: { checked: _vm.checked },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "state" }, [
                  _c(
                    "label",
                    {
                      staticStyle: { "font-size": "0.9rem" },
                      attrs: { for: _vm.labelValue },
                    },
                    [
                      _c("span", { staticClass: "d-none" }, [
                        _vm._v(_vm._s(_vm.$tc("global.doorr.agent", 2))),
                      ]),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _vm.deleteOption
                ? _c(
                    "inline-prompt",
                    {
                      staticClass: "ml-2 pb-1",
                      on: { accept: _vm.handleDelete },
                      nativeOn: {
                        click: function ($event) {
                          $event.stopPropagation()
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "preConfirmationContent",
                            fn: function () {
                              return [
                                _c("div", [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.$t(
                                          "boards.messages.removeCollaboratorConfirmation.areYouSure"
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                  _c(
                                    "b",
                                    { staticClass: "collaborator-name" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.user.givenName) +
                                          " " +
                                          _vm._s(_vm.user.familyName) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.$t(
                                          "boards.messages.removeCollaboratorConfirmation.fromThisBoard"
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.$t(
                                          "boards.messages.removeCollaboratorConfirmation.doingSoWill"
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                  _c("ul", { staticClass: "pl-2" }, [
                                    _c("li", [
                                      _vm._v(
                                        "\n                -\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "boards.messages.removeCollaboratorConsequences.moveAllClients"
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _vm._v(
                                        "\n                -\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "boards.messages.removeCollaboratorConsequences.deleteAllAutomations"
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _vm._v(
                                        "\n                -\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "boards.messages.removeCollaboratorConsequences.removeAllApplications"
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        2174321463
                      ),
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.right",
                              value: _vm.$t("global.words.delete"),
                              expression: "$t('global.words.delete')",
                              modifiers: { right: true },
                            },
                          ],
                          staticClass: "clickable ml-2",
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-trash text-danger",
                            attrs: { "aria-hidden": "true" },
                          }),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }